import { createIconComponent } from '../../factory/create-icon-component';
export const ReplenishIcon = createIconComponent(
  'ReplenishIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 6.80003C2 5.11987 2 4.27979 2.32698 3.63806C2.6146 3.07357 3.07354 2.61463 3.63803 2.32701C4.27976 2.00003 5.11984 2.00003 6.8 2.00003H8.31672C9.11834 2.00003 9.51916 2.00003 9.88103 2.0915C10.4791 2.24265 11.016 2.57447 11.4186 3.04177C11.6623 3.32454 11.8415 3.68304 12.2 4.40003C12.439 4.87803 12.5585 5.11703 12.7209 5.30554C12.9894 5.61707 13.3473 5.83829 13.746 5.93905C13.9872 6.00003 14.2544 6.00003 14.7889 6.00003H15.6C17.8402 6.00003 18.9603 6.00003 19.816 6.436C20.5686 6.8195 21.1805 7.43142 21.564 8.18407C22 9.03972 22 10.1598 22 12.4V15.6C22 17.8402 22 18.9603 21.564 19.816C21.1805 20.5686 20.5686 21.1806 19.816 21.5641C18.9603 22 17.8402 22 15.6 22H8.4C6.15979 22 5.03968 22 4.18404 21.5641C3.43139 21.1806 2.81947 20.5686 2.43597 19.816C2 18.9603 2 17.8402 2 15.6V6.80003Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 14H15M12 11V17"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
